import { type CountryCode, COUNTRIES, getCountryFromEnv } from '@/lib/country';

// Country-aware factory functions
export function getCurrencyFormatter(country: CountryCode) {
  const config = COUNTRIES[country];
  return new Intl.NumberFormat(config.lang, {
    style: 'currency',
    currency: config.currency,
  });
}

export function getNumberFormatter(country: CountryCode) {
  return new Intl.NumberFormat(COUNTRIES[country].lang);
}

export function getPercentFormatter(country: CountryCode) {
  return new Intl.NumberFormat(COUNTRIES[country].lang, {
    style: 'percent',
  });
}

export function getDateFormatter(
  country: CountryCode,
  options?: Intl.DateTimeFormatOptions
) {
  return new Intl.DateTimeFormat(COUNTRIES[country].lang, options);
}

export function getPriceRange(
  country: CountryCode,
  lowest_price: number | null,
  highest_price: number | null
) {
  if (!lowest_price || !highest_price) return '';
  const fmt = getCurrencyFormatter(country);
  return `${fmt.format(lowest_price)} - ${fmt.format(highest_price)}`;
}

// Default instances for backward compatibility (uses COUNTRY_CODE env var)
const defaultCountry = getCountryFromEnv();

export const currencyFormatter = getCurrencyFormatter(defaultCountry);
export const numberFormatter = getNumberFormatter(defaultCountry);
export const percentFormatter = getPercentFormatter(defaultCountry);
export const dateFormatter = (options?: any) =>
  getDateFormatter(defaultCountry, options);

export const priceRange = ({
  lowest_price,
  highest_price,
}: {
  lowest_price: number | null;
  highest_price: number | null;
}) => {
  return getPriceRange(defaultCountry, lowest_price, highest_price);
};
